"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var loadCheckoutContext = function loadCheckoutContext(context) {
  return {
    type: 'LOAD_CHECKOUT_CONTEXT',
    payload: {
      context: context
    }
  };
};

var updateCheckoutProduct = function updateCheckoutProduct(product) {
  return {
    type: 'UPDATE_CHECKOUT_PRODUCT',
    payload: {
      product: product
    }
  };
};

var updateCheckoutShipping = function updateCheckoutShipping(shipping) {
  return {
    type: 'UPDATE_CHECKOUT_SHIPPING',
    payload: {
      shipping: shipping
    }
  };
};

var updateCheckoutOrderItems = function updateCheckoutOrderItems(items) {
  return {
    type: 'UPDATE_CHECKOUT_ORDER_ITEMS',
    payload: {
      items: items
    }
  };
};

var createOrder = function createOrder(payload) {
  return {
    type: 'CREATE_ORDER',
    payload: payload
  };
};

var createOrderSuccess = function createOrderSuccess(order) {
  return {
    type: 'CREATE_ORDER_SUCCESS',
    payload: {
      order: order
    }
  };
};

var createOrderError = function createOrderError(error) {
  return {
    type: 'CREATE_ORDER_ERROR',
    payload: {
      error: error
    }
  };
};

var updateOrder = function updateOrder(payload) {
  return {
    type: 'UPDATE_ORDER',
    payload: payload
  };
};

var updateOrderSuccess = function updateOrderSuccess(order) {
  return {
    type: 'UPDATE_ORDER_SUCCESS',
    payload: {
      order: order
    }
  };
};

var updateOrderError = function updateOrderError(error) {
  return {
    type: 'UPDATE_ORDER_ERROR',
    payload: {
      error: error
    }
  };
};

var checkCoupon = function checkCoupon(payload) {
  return {
    type: 'CHECK_COUPON',
    payload: payload
  };
};

var checkCouponSuccess = function checkCouponSuccess(coupon) {
  return {
    type: 'CHECK_COUPON_SUCCESS',
    payload: {
      coupon: coupon
    }
  };
};

var checkCouponError = function checkCouponError(error) {
  return {
    type: 'CHECK_COUPON_ERROR',
    payload: {
      error: error
    }
  };
};

var resetCheckout = function resetCheckout() {
  return {
    type: 'RESET_CHECKOUT'
  };
};

var _default = {
  loadCheckoutContext: loadCheckoutContext,
  updateCheckoutProduct: updateCheckoutProduct,
  updateCheckoutShipping: updateCheckoutShipping,
  updateCheckoutOrderItems: updateCheckoutOrderItems,
  createOrder: createOrder,
  createOrderSuccess: createOrderSuccess,
  createOrderError: createOrderError,
  updateOrder: updateOrder,
  updateOrderSuccess: updateOrderSuccess,
  updateOrderError: updateOrderError,
  checkCoupon: checkCoupon,
  checkCouponSuccess: checkCouponSuccess,
  checkCouponError: checkCouponError,
  resetCheckout: resetCheckout
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map